import { Checkbox, DefaultButton, FontWeights, IButtonStyles, IconButton, IIconProps, mergeStyleSets, MessageBar, Modal, PrimaryButton, Stack, TextField, useTheme } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import * as React from 'react';
import { IUpdateEventTeacher } from '../../../../../Models/Event/IUpdateEventTeacher';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';

interface ITeacherPropertiesViewProps {
    eventId: number;
    isOpened: boolean
    onDismiss: () => void;
    teacher?: IUpdateEventTeacher; 
    teacherName: string;

    propertyChanged: (key: string, value: any) => void;
    statusMessage?: IStatusMessage; 
    save: (eventId: number, teacher?: IUpdateEventTeacher) => void;
}


export const TeacherPropertiesView: React.FunctionComponent<ITeacherPropertiesViewProps> = (props) => {

    
    const titleId = useId('title');
    const theme = useTheme();


    const cancelIcon: IIconProps = { iconName: 'Cancel' };
    const contentStyles = mergeStyleSets({
        container: {
            display: 'flex',
            flexFlow: 'column nowrap',
            alignItems: 'stretch',
        },
        header: [
            theme.fonts.xLargePlus,
            {
                flex: '1 1 auto',
                borderTop: `4px solid ${theme.palette.themePrimary}`,
                color: theme.palette.neutralPrimary,
                display: 'flex',
                alignItems: 'center',
                fontWeight: FontWeights.semibold,
                padding: '12px 12px 14px 24px',
            },
        ],
        body: {
            flex: '4 4 auto',
            padding: '0 24px 24px 24px',
            overflowY: 'hidden',
            selectors: {
                p: { margin: '14px 0' },
                'p:first-child': { marginTop: 0 },
                'p:last-child': { marginBottom: 0 },
            },
        },
    });
    const iconButtonStyles: Partial<IButtonStyles> = {
        root: {
            color: theme.palette.neutralPrimary,
            marginLeft: 'auto',
            marginTop: '4px',
            marginRight: '2px',
        },
        rootHovered: {
            color: theme.palette.neutralDark,
        },
    };


    return (<Modal
        titleAriaId={titleId}
        isOpen={props.isOpened}
        onDismiss={props.onDismiss}
        isBlocking={false}
        containerClassName={contentStyles.container}>
        <div className={contentStyles.header}>
            <span id={titleId}>Úprava lektora</span>
            <IconButton
                styles={iconButtonStyles}
                iconProps={cancelIcon}
                ariaLabel="Zavři"
                onClick={props.onDismiss} />
        </div>
        <div className={contentStyles.body}>
            <Stack tokens={{ childrenGap: 15 }}>
                <TextField label="Lektor" readOnly value={props.teacherName} />
                <TextField key="payment" disabled={props.teacher === undefined} label="Platba za lekci" styles={{ root: { width: 150 } }} value={props.teacher?.payment.toString()} onChange={(e, v) => props.propertyChanged("payment",v ? v : "")} />
                <Checkbox key="mainTeacher" disabled={props.teacher === undefined} label="Hlavní lektor" checked={props.teacher?.mainTeacher} onChange={(e, checked) => props.propertyChanged("mainTeacher", checked ? checked : false)} />

                {props.statusMessage ? <MessageBar messageBarType={props.statusMessage.type}>{props.statusMessage.message}</MessageBar> : null}
            </Stack>
        </div>
        <Stack horizontal tokens={{ padding: 20, childrenGap: 15 }} horizontalAlign="center">
            <PrimaryButton disabled={props.teacher === undefined} onClick={() => props.save(props.eventId, props.teacher)}>Uložit</PrimaryButton>
            <DefaultButton onClick={props.onDismiss}>Zavřít</DefaultButton>
        </Stack>
    </Modal>)
}
